import React from 'react';

const Pane = (props) => {
    return (
        <div className={'application-pane'} style={!!props && !!props.style ? props.style : {}}>
            {props.children}
        </div>
    );
}

export default Pane;
